import { Trans, useTranslation } from 'react-i18next';

import Link from 'components/Link';

import LastUpdated from './LastUpdated';
import Typography from './Typography';
import SubTitle from './SubTitle';
import Title from './Title';

const UKSupplement = () => {
  const { t } = useTranslation('terms-of-use');

  return (
    <div>
      <LastUpdated />
      <h2 className="text-2xl sm:text-5xl font-extrabold tracking-tight mb-3 sm:mb-6">
        {t('uk.supplement')}
      </h2>
      <h2 className="text-2xl sm:text-5xl font-extrabold tracking-tight mb-6 sm:mb-12">
        <Trans
          ns="terms-of-use"
          i18nKey="uk.title"
          components={{ 1: <span className="text-blue-600" /> }}
        />
      </h2>
      <div className="mb-12">
        <Typography last>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.text"
            components={{ 1: <b /> }}
          />
        </Typography>

        <Title>{t('uk.intro-t')}</Title>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.intro-p-1"
            components={{ 1: <b /> }}
          />
        </Typography>
        <Typography>{t('uk.intro-p-2')}</Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.intro-p-3"
            components={{
              1: (
                <Link
                  href="https://www.fca.org.uk/contact"
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium"
                />
              ),
            }}
          />
        </Typography>
        <Typography>{t('uk.intro-p-4')}</Typography>
        <Typography>{t('uk.intro-p-5')}</Typography>
        <Typography last>{t('uk.intro-p-6')}</Typography>

        <Title>{t('uk.service-t')}</Title>
        <SubTitle>{t('uk.service-a-t')}</SubTitle>
        <Typography>{t('uk.service-a-p')}</Typography>

        <SubTitle>{t('uk.service-b-t')}</SubTitle>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-1"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <SubTitle>{t('uk.service-b-t-1')}</SubTitle>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-2"
            components={{ 1: <b className="mr-4" />, 2: <b /> }}
          />
        </Typography>
        <SubTitle>{t('uk.service-b-t-2')}</SubTitle>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-3"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-4"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-5"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-6"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-7"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <div className="pl-6">
          <Typography>
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-7-a"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-7-b"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-7-c"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-7-d"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-7-e"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-7-f"
              components={{ 1: <b /> }}
            />
          </Typography>
        </div>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-8"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-9"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-10"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-11"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-12"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <div className="pl-6">
          <Typography>
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-12-a"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-12-b"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-12-c"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-12-d"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-12-e"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-12-f"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-b-p-12-g"
              components={{ 1: <b /> }}
            />
          </Typography>
        </div>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-13"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-14"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-15"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-16"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-17"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-18"
            components={{
              1: <b className="mr-4" />,
              2: (
                <Link
                  href="mailto:support@smart-enroll.com"
                  className="font-medium"
                />
              ),
            }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-19"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-20"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-21"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-22"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-23"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-24"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography last>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-b-p-25"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>

        <SubTitle>{t('uk.service-c-t')}</SubTitle>
        <Typography last>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-c-p"
            components={{
              1: (
                <Link
                  href="mailto:support@smart-enroll.com"
                  className="font-medium"
                />
              ),
            }}
          />
        </Typography>

        <SubTitle>{t('uk.service-d-t')}</SubTitle>
        <Typography>{t('uk.service-d-p-1')}</Typography>
        <Typography>{t('uk.service-d-p-2')}</Typography>
        <Typography last>{t('uk.service-d-p-3')}</Typography>

        <SubTitle>{t('uk.service-e-t')}</SubTitle>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-e-p-1"
            components={{
              1: (
                <Link
                  href="https://smart-enroll.com/privacy-policy/EN"
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium"
                />
              ),
            }}
          />
        </Typography>
        <Typography last>{t('uk.service-e-p-2')}</Typography>

        <SubTitle>{t('uk.service-f-t')}</SubTitle>
        <Typography last>{t('uk.service-f-p')}</Typography>

        <SubTitle>{t('uk.service-g-t')}</SubTitle>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-1"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-2"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-3"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-4"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-5"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-6"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-7"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-8"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-9"
            components={{
              1: <b className="mr-4" />,
              2: (
                <Link
                  href="mailto:support@smart-enroll.com"
                  className="font-medium"
                />
              ),
            }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-10"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-11"
            components={{
              1: <b className="mr-4" />,
              2: (
                <Link
                  href="mailto:support@smart-enroll.com"
                  className="font-medium"
                />
              ),
            }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-12"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-13"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-14"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-15"
            components={{
              1: <b className="mr-4" />,
              2: (
                <Link
                  href="mailto:support@smart-enroll.com"
                  className="font-medium"
                />
              ),
            }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-16"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-17"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography last>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-g-p-18"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>

        <SubTitle>{t('uk.service-h-t')}</SubTitle>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-1"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-2"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-3"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-4"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <div className="pl-6">
          <Typography>
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-h-p-4-a"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-h-p-4-b"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-h-p-4-c"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-h-p-4-d"
              components={{ 1: <b /> }}
            />
            <br />
            <Trans
              ns="terms-of-use"
              i18nKey="uk.service-h-p-4-e"
              components={{ 1: <b /> }}
            />
          </Typography>
        </div>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-5"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-6"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-7"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-8"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
        <Typography last>
          <Trans
            ns="terms-of-use"
            i18nKey="uk.service-h-p-9"
            components={{ 1: <b className="mr-4" /> }}
          />
        </Typography>
      </div>
    </div>
  );
};

export default UKSupplement;
